import React from "react";
import { Outlet } from "react-router-dom";

import { IgPageContent } from "@src/utils/IgPageContent";

import { AlertBanner } from "./alerts/AlertBanner";
import { AppLayoutShell } from "./layout/AppLayoutShell";

export const FullPageProvider = () => {
  return (
    <AppLayoutShell banner={<AlertBanner />} maxWidth={1600}>
      <IgPageContent>
        <Outlet />
      </IgPageContent>
    </AppLayoutShell>
  );
};
